export const initialState = {
  active: null,
  dollarsGained: 0,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_TOOLS':
      if (action.payload) {
        return Object.assign({}, state, action.payload);
      }
    default:
      return state;
  }
}
